module.exports = __webpack_public_path__ + "img/louis-pasteur.4aa66cc9.png";